var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgErrorIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666992 11C0.666992 5.01542 5.51578 0.166626 11.5003 0.166626C17.4849 0.166626 22.3337 5.01542 22.3337 11C22.3337 16.9845 17.4849 21.8333 11.5003 21.8333C5.51578 21.8333 0.666992 16.9845 0.666992 11ZM16.7601 14.5548C16.9635 14.3514 16.9635 14.0226 16.7601 13.8192L13.9214 11.0021L16.7645 8.18939C16.9678 7.98601 16.9678 7.65714 16.7645 7.45376L15.0509 5.74016C14.8475 5.53677 14.5186 5.53677 14.3152 5.74016L11.4982 8.57885L8.68543 5.73583C8.48205 5.53245 8.15318 5.53245 7.9498 5.73583L6.2362 7.44943C6.03281 7.65281 6.03281 7.98169 6.2362 8.18507L9.07489 11.0021L6.2362 13.8149C6.03281 14.0182 6.03281 14.3471 6.2362 14.5505L7.94547 16.2641C8.14885 16.4675 8.47772 16.4675 8.68111 16.2641L11.4982 13.4254L14.3109 16.2641C14.5143 16.4675 14.8431 16.4675 15.0465 16.2641L16.7601 14.5548Z",
    fill: "#D0021B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgErrorIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/error-icon.a413068df1f167c35f9eb0d7411eb737.svg";